import React from 'react'
import Navbar from '../../Components/Navbar'

function Shoes() {
    return (
        <div>
            <Navbar/>
            <h1>Shoes.</h1>
        </div>
    )
}

export default Shoes
